/* compare_expanded_icon.svg.js */

"use strict";
module.exports = {
    icon: `    
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 22.7 20.5" style="enable-background:new 0 0 22.7 20.5;" xml:space="preserve">
		<style type="text/css">
			.st0{fill:#59595C;}
			.st1{fill:#58595B;}
		</style>
		<path class="st0" d="M20.2,12.5H2.5c-1.2,0-2.2-0.9-2.2-2s1-2,2.2-2h17.6c1.2,0,2.2,0.9,2.2,2S21.4,12.5,20.2,12.5z"/>
		<path class="st1" d="M16.3,6.3L11.4,1l-5,5.4H16.3z"/>
		<path class="st1" d="M16.3,14.5l-4.9,5.4l-5-5.4H16.3z"/>
	</svg>
         `,
};
